import { actions as exportActions, actions, ExportName } from 'actions/exportToCsvActions';
import { connect } from 'react-redux';
import { Global } from 'state/Global';
import { handleExportMeetingsToCsv } from 'utils/exportUtils';
import MeetingsToolbar from '../../components/Meetings/MeetingsTab/MeetingsToolbar';
import { selectExportState } from '../../selectors/exportToCsvSelector';

const mapStateToProps = (state: Global) => {
  const exportState = selectExportState(state);
  return {
    isExporting: exportState.isBusy
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  handleExportData: async () => {
    dispatch(actions.doCsvExport(ExportName.MEETINGS, handleExportMeetingsToCsv));
  },
  resetExportState: () => {
    dispatch(exportActions.fetchCsvDataReset());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MeetingsToolbar);
